/**
 * Routes a patient reaches by link, carrying their own scoped token in the URL.
 *
 * These must never be treated as a staff session. Two things go wrong if they
 * are: `AuthContext` calls `/auth/me` with a stale staff token from a previous
 * user of the browser, and the 401 handler then redirects to `/login` and
 * replaces the address bar. The patient's link is gone, and it is not
 * recoverable from anywhere in the UI.
 *
 * Shared between `AuthContext` and the axios error map so both agree on what
 * counts as public. The handoff patched only `AuthContext` and only for
 * `/claim-portal`, which left both the redirect and the public chart link
 * exposed to the same failure.
 */
export const PUBLIC_PATHS = ['/claim-portal', '/s/'] as const;

export function isPublicPath(pathname: string = window.location.pathname): boolean {
  return PUBLIC_PATHS.some((p) => (p.endsWith('/') ? pathname.startsWith(p) : pathname === p));
}
